import { Injectable } from '@angular/core';
import { AswMasterService } from '@lib/services';
import { Observable, filter, firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AswMasterHelper {
  constructor(private readonly aswMasterSerice: AswMasterService) {}

  getASWDB<T>(table: string) {
    // use <any> for cases when the shape of objects from list are not defined in documents
    return firstValueFrom<Array<any> | Array<T>>(
      this.aswMasterSerice.getAswMasterByKey$(table).pipe(filter((val) => !!val))
    );
  }

  get_aswdb_observable<T>(table: string) {
    return this.aswMasterSerice.getAswMasterByKey$(table).pipe(filter((val) => !!val)) as Observable<Array<T>>;
  }
}
